var escape = require("../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".scroll[data-v-4a69ef11]{display:flex;flex-direction:column;align-items:center;position:fixed;bottom:40px;left:40px;z-index:4}.socials[data-v-4a69ef11]{width:35px;height:35px;margin-bottom:12px;background-size:cover;z-index:3}a[data-v-4a69ef11]{margin-bottom:0}.github[data-v-4a69ef11]{background-image:url(" + escape(require("./assets/github.png")) + ");width:35px;height:35px}.linkedin[data-v-4a69ef11]{background-image:url(" + escape(require("./assets/linkedin.png")) + ");width:35px;height:35px}.mouse[data-v-4a69ef11]{background-image:url(" + escape(require("./assets/mouse.png")) + ");margin-bottom:15px}.email[data-v-4a69ef11]{background-image:url(" + escape(require("./assets/mail.png")) + ")}.line line[data-v-4a69ef11]{stroke-width:1.4px;stroke:#000}.opacity[data-v-4a69ef11]{opacity:.6}@media screen and (max-width:1100px){.scroll[data-v-4a69ef11]{display:none}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4a69ef11","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/socials.vue
// module id = 293
// module chunks = 0